import React, { Component, Fragment } from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import MaterialTable from 'material-table';
import { Input, Select, notification, Checkbox } from 'antd';

import { Can, columns, USER_RANK_ORG } from '../../constants';
import {
  title,
  requestLookups,
  noteLookups,
  materialTableProps,
  validateProfileFields,
  generateMaterialFilter,
  loadDefaultFilter,
  ResetButton,
} from '../../utils';

import {
  organisationService,
  requestService,
  userService,
  noteService,
  organisationUserService,
} from '../../services';

import { BackButton } from '../../components';

var isChecked = val =>
  val === true || val === 'true' || val === 1 || val === 't';

class OrganisationPage extends Component {
  constructor(props) {
    super(props);
    const { id } = this.props.params;
    const tableKey_notes = 'note_organisation';
    const tableKey_requests = 'request_organisation';

    this.state = {
      id: id,
      org: {
        __type: 'Organisation',
      },
      req: [],
      action_fields: [],
      sectors: [],
      subsectors: [],
      users: [],
      associations: [],
      isUpToDate: true,
      errors: {},
      _tableKey_notes: tableKey_notes,
      notes: {
        rendered: true,
        possibleColumns: (columns.getKeys('notes') || []).map(c => {
          var completeCol = {
            ...columns['notes']()[c],
            field: c.toLowerCase(),
          };
          loadDefaultFilter(tableKey_notes, completeCol);
          return { ...completeCol };
        }),
      },
      _tableKey_requests: tableKey_requests,
      requests: {
        rendered: true,
        possibleColumns: (columns.getKeys('requests') || []).map(c => {
          var completeCol = {
            ...columns['requests']()[c],
            field: c.toLowerCase(),
          };
          loadDefaultFilter(tableKey_requests, completeCol);
          return { ...completeCol };
        }),
      },
    };

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleCreateSubmit = this.handleCreateSubmit.bind(this);
    this.handleNotesPagination = this.handleNotesPagination.bind(this);
    this.validateFields = this.validateFields.bind(this);
  }

  componentDidMount() {
    if (!this.props.create && this.state.id) {
      let orgUpdates = {};

      organisationService
        .get(this.state.id)
        .then(result => {
          orgUpdates = { ...orgUpdates, ...result };

          return organisationUserService.getAssociationOrg(this.state.id);
        })
        .then(result => {
          if (result.length > 0) {
            orgUpdates = {
              ...orgUpdates,
              associated_user_id: result[0].user.id,
              association_id: result[0].id,
            };

            if (!(this.props.create || this.props.edit)) {
              orgUpdates = {
                ...orgUpdates,
                associated_user_name:
                  result[0].user.name + ' ' + result[0].user.surname,
              };
            }
          }

          this.setState({ org: { ...this.state.org, ...orgUpdates } });
        })
        .catch(e => {
          this.setState(() => {
            throw new Error(e);
          });
        });

      if (!this.props.edit) {
        requestLookups(this, this.state.requests.possibleColumns);
        noteLookups(this, this.state.notes.possibleColumns);
      }
    }

    if (this.props.create || this.props.edit) {
      organisationService.getActionFields().then(result => {
        this.setState({
          action_fields: result,
        });
      });

      organisationService.getSectors().then(result => {
        this.setState({
          sectors: result,
        });
      });

      organisationService.getSubSectors().then(result => {
        this.setState({
          subsectors: result,
        });
      });

      userService.list().then(result => {
        this.setState({
          users: result,
        });
      });

      organisationUserService.get().then(result => {
        this.setState({
          associations: result,
        });
      });
    }

    window.onbeforeunload = function () {
      if (!this.state.isUpToDate) return 'Refresh';
    }.bind(this);
  }

  handleCheckboxChange(e) {
    e.preventDefault();
    const { edit } = this.props;
    const { isUpToDate } = this.state;

    const newIsUpToDate = edit && isUpToDate ? false : isUpToDate;

    this.setState({
      org: {
        ...this.state.org,
        [e.target.name]: e.target.checked,
      },
      isUpToDate: newIsUpToDate,
    });
  }

  handleChange(e) {
    e.preventDefault();
    const { edit } = this.props;
    const { isUpToDate } = this.state;

    const newIsUpToDate = edit && isUpToDate ? false : isUpToDate;

    this.setState({
      org: {
        ...this.state.org,
        [e.target.name]: e.target.value,
      },
      isUpToDate: newIsUpToDate,
    });
  }

  handleSelectChange(name) {
    return value => {
      const { edit } = this.props;
      const { isUpToDate } = this.state;

      const newIsUpToDate = edit && isUpToDate ? false : isUpToDate;

      this.setState({
        org: {
          ...this.state.org,
          [name]: value,
        },
        isUpToDate: newIsUpToDate,
      });
    };
  }

  handleEditSubmit(e) {
    e.preventDefault();

    if (!this.validateFields()) return;

    const { id, org } = this.state;

    organisationService
      .edit(id, org)
      .then(() => {
        notification.open({
          message: 'Enregistrement effectué',
          description: 'Vos changements ont été enregistrés avec succès.',
          placement: 'bottomRight',
        });
        this.setState({
          isUpToDate: true,
        });
        this.props.navigate(`/organisations/${id}`, { replace: true });
      })
      .catch(() => {
        notification.open({
          message: "Une erreur s'est produite",
          description: 'Veuillez réessayer ou contacter un administrateur.',
          placement: 'bottomRight',
        });
        this.setState({
          isUpToDate: false,
        });
      });
  }

  handleCreateSubmit(e) {
    e.preventDefault();

    if (!this.validateFields()) return;

    const { org } = this.state;

    organisationService
      .create(org)
      .then(o => {
        notification.open({
          message: 'Organisme créé',
          description: "L'organisme a été créé avec succès.",
          placement: 'bottomRight',
        });

        this.props.navigate(`/organisations/${o.id}`, { replace: true });
      })
      .catch(() => {
        notification.open({
          message: "Une erreur s'est produite",
          description: 'Veuillez réessayer ou contacter un administrateur.',
          placement: 'bottomRight',
        });
      });
  }

  validateFields() {
    const { org } = this.state;
    var validation = validateProfileFields(org, [
      'name',
      'email_general',
      'tel_service',
      'city',
      'region',
      'action_field_id',
      'sector_id',
      'subsector_id',
      'associated_user_id',
    ]);

    this.setState({ errors: validation.errors });
    return !validation.hasError;
  }

  generatePage(pageTitle) {
    if (this.props.edit) {
      return this.generateEditPage(pageTitle);
    } else if (this.props.create) {
      return this.generateCreatePage(pageTitle);
    } else {
      return this.generateShowPage(pageTitle);
    }
  }

  generateShowPage(pageTitle) {
    const { org, requests, notes } = this.state;

    return (
      <Fragment>
        <BackButton />
        <h1>{pageTitle}</h1>

        <section>
          <Can do="read" on={org}>
            <Can do="edit" on={org}>
              <article className="buttons">
                <a
                  className="button full"
                  onClick={() =>
                    this.props.navigate(
                      '/organisations/' + this.state.id + '/edit',
                      { replace: true }
                    )
                  }
                >
                  Éditer
                </a>
              </article>
            </Can>
            <article className="box title-box">
              <h2>{org.name}</h2>
            </article>
            <article className="box">
              <ul className="profile-main-content larger read">
                <Can do="num_org" on={org}>
                  <li>
                    <label>Numéro d&apos;organisme : </label>
                    <b>{org.organisation_number}</b>
                  </li>
                </Can>
                <li>
                  <label>Nom, selon lettres-patentes : </label>
                  <b>{org.patent_name}</b>
                </li>
                <li>
                  <label>Nom organismes, Lettres : </label>
                  <b>{org.name}</b>
                </li>
                <li>
                  <label>Enregistrement ARC : </label>
                  <b>{org.arc}</b>
                </li>
                <li>
                  <label>Enregistrement NEQ : </label>
                  <b>{org.neq}</b>
                </li>
                <li>
                  <label>Courriel général : </label>
                  <b>{org.email_general}</b>
                </li>
                <li>
                  <label>Site internet : </label>
                  <b>{org.website}</b>
                </li>
                <li>
                  <label>Téléphone service : </label>
                  <b>{org.tel_service}</b>
                </li>
                <li>
                  <label>Téléphone administration : </label>
                  <b>{org.tel_admin}</b>
                </li>
                <li>
                  <label>Cellulaire responsable : </label>
                  <b>{org.tel_responsible}</b>
                </li>
                <li>
                  <label>Courriel responsable : </label>
                  <b>{org.mail_responsible}</b>
                </li>
                <li>
                  <label>Adresse : </label>
                  <b>{org.address}</b>
                </li>
                <li>
                  <label>Code Postal : </label>
                  <b>{org.postal_code}</b>
                </li>
                <li>
                  <label>Ville / Municipalité : </label>
                  <b>{org.city}</b>
                </li>
                <li>
                  <label>Arrondissement : </label>
                  <b>{org.borough}</b>
                </li>
                <li>
                  <label>Quartier (si applicable) : </label>
                  <b>{org.district}</b>
                </li>
                <li>
                  <label>Région : </label>
                  <b>{org.region}</b>
                </li>
                <li>
                  <label>Ville ou MRC : </label>
                  <b>{org.mrc}</b>
                </li>
                <Can do="action_fields" on={org}>
                  <li>
                    <label>Champ d&apos;action : </label>
                    <b>{org.action_field ? org.action_field.label : ''}</b>
                  </li>
                </Can>
                <Can do="sectors" on={org}>
                  <li>
                    <label>Secteur d&apos;intervention : </label>
                    <b>{org.sector ? org.sector.label : ''}</b>
                  </li>
                </Can>
                <Can do="subsectors" on={org}>
                  <li>
                    <label>Sous-secteur : </label>
                    <b>{org.subsector ? org.subsector.label : ''}</b>
                  </li>
                </Can>
                <li>
                  <label>Appellation présidence : </label>
                  <b>{org.presidency_appellation}</b>
                </li>
                <li>
                  <label>Prénom présidence : </label>
                  <b>{org.presidency_name}</b>
                </li>
                <li>
                  <label>Nom présidence : </label>
                  <b>{org.presidency_surname}</b>
                </li>
                <li>
                  <label>Appellation responsable : </label>
                  <b>{org.responsible_appellation}</b>
                </li>
                <li>
                  <label>Prénom responsable : </label>
                  <b>{org.responsible_name}</b>
                </li>
                <li>
                  <label>Nom responsable : </label>
                  <b>{org.responsible_surname}</b>
                </li>
                <li>
                  <label>Année d&apos;association : </label>
                  <b>{org.organization_year}</b>
                </li>
                <Can do="yearly_follow" on={org}>
                  <li>
                    <label>Suivi triennal : </label>
                    <b>{org.yearly_follow}</b>
                  </li>
                </Can>
                <li>
                  <label>Territoire desservi : </label>
                  <b>{org.territory}</b>
                </li>
                <li>
                  <label>Mission : </label>
                  <b>{org.mission}</b>
                </li>
                <li>
                  <label>Services offerts : </label>
                  <b>{org.service}</b>
                </li>
                <li>
                  <label>Clientèle : </label>
                  <b>{org.customer}</b>
                </li>
                <li>
                  <label>
                    Propriétaire de l&apos;édifice qu&apos;il occupe :
                  </label>
                  <b>{org.building_owner ? 'Oui' : 'Non'}</b>
                </li>
                <li>
                  <label>Propriétaire d&apos;un autre édifice : </label>
                  <b>{org.other_building_owner ? 'Oui' : 'Non'}</b>
                </li>
                <li>
                  <label>Adresse de l&apos;édifice : </label>
                  <b>{org.building_address}</b>
                </li>
                <li>
                  <label>Propriétaire de la Fondation : </label>
                  <b>{org.foundation_owner ? 'Oui' : 'Non'}</b>
                </li>
                <li>
                  <label>Nom de la Fondation : </label>
                  <b>{org.foundation_name}</b>
                </li>
                <li>
                  <label>Adresse fiduciaire : </label>
                  <b>{org.fiduciary_address}</b>
                </li>
                <li>
                  <label>Ville fiduciaire : </label>
                  <b>{org.fiduciary_city}</b>
                </li>
                <li>
                  <label>Province fiduciaire : </label>
                  <b>{org.fiduciary_province}</b>
                </li>
                <li>
                  <label>Code postal fiduciaire : </label>
                  <b>{org.fiduciary_postal_code}</b>
                </li>
                <li>
                  <label>Point de service #1 : </label>
                  <b>{org.service_point_1}</b>
                </li>
                <li>
                  <label>Point de service #2 : </label>
                  <b>{org.service_point_2}</b>
                </li>
                <li>
                  <label>Point de service #3 : </label>
                  <b>{org.service_point_3}</b>
                </li>
                <li>
                  <label>Utilisateur associé : </label>
                  <b>{org.associated_user_name}</b>
                </li>
              </ul>
            </article>

            <Can do="list" on={'Request'}>
              <article
                className={
                  'box table-box' + (requests.rendered ? ' show' : ' hide')
                }
              >
                <h3>Demandes</h3>
                <MaterialTable
                  title={'Centraide - Liste des demandes - ' + org.name}
                  columns={requests.possibleColumns}
                  data={query =>
                    this.handleRequestsPagination(query, this.state.id)
                  }
                  {...materialTableProps(
                    this.state._tableKey_requests,
                    'Centraide - Liste des demandes - ' + org.name
                  )}
                  onRowClick={(event, rowData) => {
                    this.props.navigate(`/requests/${rowData.id}`);
                  }}
                  actions={[]}
                />
              </article>
            </Can>

            <Can do="read" on={'Note'}>
              <Can do="edit" on={'Note'} passThrough>
                {canEdit => (
                  <Can do="create" on={'Note'} passThrough>
                    {canCreate => (
                      <article
                        className={
                          'box table-box' + (notes.rendered ? ' show' : ' hide')
                        }
                      >
                        <h3>Notes</h3>
                        <ResetButton tableKey={this.state._tableKey_notes} />

                        <MaterialTable
                          title={'Centraide - Liste des notes - ' + org.name}
                          columns={notes.possibleColumns}
                          data={query =>
                            this.handleNotesPagination(query, this.state.id)
                          }
                          {...materialTableProps(
                            this.state._tableKey_notes,
                            'Centraide - Liste des notes - ' + org.name
                          )}
                          onRowClick={(_, rowData) => {
                            this.props.navigate(`/notes/${rowData.id}`);
                          }}
                          actions={[
                            (canCreate && {
                              icon: 'add',
                              tooltip: 'Ajouter une note',
                              iconProps: { className: 'main' },
                              isFreeAction: true,
                              onClick: () =>
                                this.props.navigate(
                                  `/organisations/${org.id}/notes/new`
                                ),
                            }) ||
                              null,
                            (canEdit && {
                              icon: 'edit',
                              tooltip: 'Éditer la note',
                              onClick: (_, rowData) =>
                                this.props.navigate(
                                  `/notes/${rowData.id}/edit`
                                ),
                            }) ||
                              null,
                          ]}
                        />
                      </article>
                    )}
                  </Can>
                )}
              </Can>
            </Can>
          </Can>
        </section>
      </Fragment>
    );
  }

  generateRegionOption() {
    var options = [];

    var regions = [
      'Bas-Saint-Laurent',
      'Capitale-Nationale',
      'Chaudière-Appalaches',
    ];

    regions.forEach(el => {
      options.push(
        <Select.Option key={el} value={el}>
          {el}
        </Select.Option>
      );
    });

    return options;
  }

  generateBoroughOption() {
    var options = [];

    var boroughs = [
      '',
      'Beauport',
      'Charlesbourg',
      'Chutes-de-la-Chaudières-Est',
      'Chutes-de-la-Chaudières-Ouest',
      'Desjardins',
      'La Cité-Limoilou',
      'La Haute-Saint-Charles',
      'Les Rivières',
      'Sainte-Foy-Sillery-Cap-Rouge',
    ];

    boroughs.forEach(el => {
      options.push(
        <Select.Option key={el} value={el}>
          {el}
        </Select.Option>
      );
    });

    return options;
  }

  generateDistrictOption() {
    var options = [];

    var districts = [
      ' ',
      'Adstock',
      'Aéroport',
      'Albertville',
      'Amqui',
      'Armagh',
      'Auclair',
      'Baie-des-Sables',
      'Baie-Saint-Paul',
      'Baie-Sainte-Catherine',
      'Beauceville',
      'Beaulac-Garthby',
      'Beaumont',
      'Beaupré',
      'Berthier-sur-Mer',
      'Biencourt',
      'Boischatel',
      'Bourg-Royal',
      'Cacouna',
      'Cap-Rouge',
      'Cap-Saint-Ignace',
      'Cap-Santé',
      'Causapscal',
      'Charny',
      'Château-Richer',
      'Châtel',
      'Chutes-Montmorency',
      'Cité-Universitaire',
      'Clermont',
      'Dégelis',
      'Deschambault-Grondines',
      'Disraeli',
      'Donnacona',
      'Dosquet',
      'Duberger–les Saules',
      'East Broughton',
      'Esprit-Saint',
      'Fossambault-sur-le-Lac',
      'Frampton',
      'Grand-Métis',
      'Grosses-Roches',
      'Honfleur',
      'Irlande',
      'Jésuites',
      'Kamouraska',
      "Kinnear's Mills",
      "L'Ancienne-Lorette",
      "L'Ange-Gardien",
      "L'Isle-aux-Coudres",
      "L'Isle-Verte",
      "L'Islet",
      'La Durantaye',
      'La Guadeloupe',
      'La Malbaie',
      'La Pocatière',
      'La Rédemption',
      'La Trinité-des-Monts',
      'Lac-au-Saumon',
      'Lac-Beauport',
      'Lac-des-Aigles',
      'Lac-Etchemin',
      'Lac-Frontière',
      'Lac-Poulin',
      'Lac-Saint-Charles',
      'Lac-Saint-Joseph',
      'Lac-Sergent',
      'Lairet',
      'Laurentides',
      'Laurier-Station',
      'Leclercville',
      'Lejeune',
      'Les Éboulements',
      'Les Hauteurs',
      'Les Méchins',
      'Lévis',
      'Lévis',
      'Loretteville',
      'Lotbinière',
      'Maizerets',
      'Matane',
      'Métis-sur-Mer',
      'Mont-Carmel',
      'Mont-Joli',
      'Montcalm',
      'Montmagny',
      'Neufchâtel-Est–Lebourgneuf',
      'Neuville',
      'Notre-Dame-Auxiliatrice-de-Buckland',
      'Notre-Dame-des-Anges',
      'Notre-Dame-des-Laurentides',
      'Notre-Dame-des-Monts',
      'Notre-Dame-des-Neiges',
      'Notre-Dame-des-Pins',
      'Notre-Dame-des-Sept-Douleurs',
      'Notre-Dame-du-Portage',
      'Notre-Dame-du-Rosaire',
      "Notre-Dame-du-Sacré-Cœur-d'Issoudun",
      'Orsainville',
      'Packington',
      'Padoue',
      'Petite-Rivière-Saint-François',
      'Pintendre',
      'Plateau',
      'Pohénégamook',
      'Pointe-de-Sainte-Foy',
      'Pont-Rouge',
      'Portneuf',
      'Price',
      'Québec',
      'Rimouski',
      'Rivière-à-Pierre',
      'Rivière-Bleue',
      'Rivière-du-Loup',
      'Rivière-Ouelle',
      'Sacré-Cœur-de-Jésus',
      'Saint-Adalbert',
      'Saint-Adelme',
      "Saint-Adrien-d'Irlande",
      'Saint-Agapit',
      'Saint-Aimé-des-Lacs',
      'Saint-Alban',
      'Saint-Alexandre-de-Kamouraska',
      'Saint-Alexandre-des-Lacs',
      'Saint-Alfred',
      'Saint-Anaclet-de-Lessard',
      'Saint-André',
      'Saint-Anselme',
      "Saint-Antoine-de-l'Isle-aux-Grues",
      'Saint-Antoine-de-Tilly',
      'Saint-Antonin',
      'Saint-Apollinaire',
      'Saint-Arsène',
      'Saint-Athanase',
      'Saint-Aubert',
      'Saint-Augustin-de-Desmaures',
      'Saint-Basile',
      'Saint-Benjamin',
      'Saint-Benoît-Labre',
      'Saint-Bernard',
      'Saint-Bruno-de-Kamouraska',
      'Saint-Camille-de-Lellis',
      'Saint-Casimir',
      'Saint-Charles-de-Bellechasse',
      'Saint-Charles-Garnier',
      'Saint-Clément',
      'Saint-Cléophas',
      'Saint-Côme–Linière',
      'Saint-Cyprien',
      'Saint-Cyprien',
      'Saint-Cyrille-de-Lessard',
      'Saint-Damase',
      "Saint-Damase-de-L'Islet",
      'Saint-Damien-de-Buckland',
      'Saint-Denis-De La Bouteillerie',
      'Saint-Donat',
      'Saint-Édouard-de-Lotbinière',
      'Saint-Éloi',
      'Saint-Elzéar',
      'Saint-Elzéar-de-Témiscouata',
      'Saint-Émile',
      'Saint-Éphrem-de-Beauce',
      'Saint-Épiphane',
      'Saint-Étienne-de-Lauzon',
      'Saint-Eugène-de-Ladrière',
      'Saint-Eusèbe',
      'Saint-Évariste-de-Forsyth',
      'Saint-Fabien',
      'Saint-Fabien-de-Panet',
      'Saint-Ferréol-les-Neiges',
      'Saint-Flavien',
      'Saint-Fortunat',
      "Saint-François-de-l'Île-d'Orléans",
      'Saint-François-de-la-Rivière-du-Sud',
      'Saint-François-Xavier-de-Viger',
      'Saint-Frédéric',
      'Saint-Gabriel-de-Rimouski',
      'Saint-Gabriel-de-Valcartier',
      'Saint-Gabriel-Lalemant',
      'Saint-Gédéon-de-Beauce',
      'Saint-Georges',
      'Saint-Germain',
      'Saint-Gervais',
      'Saint-Gilbert',
      'Saint-Gilles',
      'Saint-Guy',
      'Saint-Henri',
      'Saint-Hilaire-de-Dorset',
      'Saint-Hilarion',
      'Saint-Honoré-de-Shenley',
      'Saint-Honoré-de-Témiscouata',
      'Saint-Hubert-de-Rivière-du-Loup',
      'Saint-Irénée',
      'Saint-Isidore',
      'Saint-Jacques-de-Leeds',
      'Saint-Jacques-le-Majeur-de-Wolfestown',
      'Saint-Janvier-de-Joly',
      'Saint-Jean-Baptiste',
      'Saint-Jean-Chrysostome',
      'Saint-Jean-de-Brébeuf',
      'Saint-Jean-de-Cherbourg',
      'Saint-Jean-de-Dieu',
      "Saint-Jean-de-l'Île-d'Orléans",
      'Saint-Jean-de-la-Lande',
      'Saint-Jean-Port-Joli',
      'Saint-Joachim',
      'Saint-Joseph-de-Beauce',
      'Saint-Joseph-de-Coleraine',
      'Saint-Joseph-de-Kamouraska',
      'Saint-Joseph-de-la-Pointe-De-Lévy',
      'Saint-Joseph-de-Lepage',
      'Saint-Joseph-des-Érables',
      'Saint-Jules',
      'Saint-Julien',
      'Saint-Just-de-Bretenières',
      'Saint-Juste-du-Lac',
      'Saint-Lambert-de-Lauzon',
      "Saint-Laurent-de-l'Île-d'Orléans",
      'Saint-Lazare-de-Bellechasse',
      'Saint-Léandre',
      'Saint-Léon-de-Standon',
      'Saint-Léon-le-Grand',
      'Saint-Léonard-de-Portneuf',
      'Saint-Louis',
      'Saint-Louis-de-Gonzague',
      'Saint-Louis-de-Gonzague-du-Cap-Tourmente',
      'Saint-Louis-du-Ha! Ha!',
      'Saint-Luc-de-Bellechasse',
      'Saint-Magloire',
      'Saint-Malachie',
      'Saint-Marc-des-Carrières',
      'Saint-Marc-du-Lac-Long',
      'Saint-Marcel',
      'Saint-Marcellin',
      'Saint-Martin',
      'Saint-Mathieu-de-Rioux',
      'Saint-Médard',
      'Saint-Michel',
      'Saint-Michel-de-Bellechasse',
      'Saint-Michel-du-Squatec',
      'Saint-Modeste',
      'Saint-Moïse',
      'Saint-Narcisse-de-Beaurivage',
      'Saint-Narcisse-de-Rimouski',
      'Saint-Nazaire-de-Dorchester',
      'Saint-Nérée-de-Bellechasse',
      'Saint-Nicolas',
      'Saint-Noël',
      'Saint-Octave-de-Métis',
      'Saint-Odilon-de-Cranbourne',
      'Saint-Omer',
      "Saint-Onésime-d'Ixworth",
      'Saint-Pacôme',
      'Saint-Pamphile',
      'Saint-Pascal',
      'Saint-Patrice-de-Beaurivage',
      'Saint-Paul-de-la-Croix',
      'Saint-Paul-de-Montminy',
      'Saint-Philémon',
      'Saint-Philibert',
      'Saint-Philippe-de-Néri',
      'Saint-Pierre-de-Broughton',
      "Saint-Pierre-de-l'Île-d'Orléans",
      'Saint-Pierre-de-la-Rivière-du-Sud',
      'Saint-Pierre-de-Lamy',
      'Saint-Prosper',
      'Saint-Raphaël',
      'Saint-Raymond',
      'Saint-Rédempteur',
      'Saint-René',
      'Saint-René-de-Matane',
      'Saint-Roch',
      'Saint-Roch-des-Aulnaies',
      'Saint-Rodrigue',
      'Saint-Romuald',
      'Saint-Sacrement',
      'Saint-Sauveur',
      'Saint-Séverin',
      'Saint-Siméon',
      'Saint-Simon',
      'Saint-Simon-les-Mines',
      'Saint-Sylvestre',
      'Saint-Tharcisius',
      'Saint-Théophile',
      'Saint-Thuribe',
      'Saint-Tite-des-Caps',
      'Saint-Ubalde',
      'Saint-Ulric',
      'Saint-Urbain',
      'Saint-Valérien',
      'Saint-Vallier',
      'Saint-Vianney',
      'Saint-Victor',
      'Saint-Zacharie',
      'Saint-Zénon-du-Lac-Humqui',
      'Sainte-Agathe-de-Lotbinière',
      'Sainte-Angèle-de-Mérici',
      'Sainte-Anne-de-Beaupré',
      'Sainte-Anne-de-la-Pocatière',
      'Sainte-Apolline-de-Patton',
      'Sainte-Aurélie',
      'Sainte-Brigitte-de-Laval',
      'Sainte-Catherine-de-la-Jacques-Cartier',
      "Sainte-Christine-d'Auvergne",
      'Sainte-Claire',
      'Sainte-Clotilde-de-Beauce',
      'Sainte-Croix',
      'Sainte-Euphémie-sur-Rivière-du-Sud',
      'Sainte-Famille',
      'Sainte-Félicité',
      'Sainte-Félicité',
      'Sainte-Flavie',
      'Sainte-Florence',
      'Sainte-Françoise',
      'Sainte-Hélène-de-Breakeyville',
      'Sainte-Hélène-de-Kamouraska',
      'Sainte-Hénédine',
      'Sainte-Irène',
      "Sainte-Jeanne-d'Arc",
      'Sainte-Justine',
      'Sainte-Louise',
      'Sainte-Luce',
      'Sainte-Lucie-de-Beauregard',
      'Sainte-Marguerite',
      'Sainte-Marguerite-Marie',
      'Sainte-Paule',
      'Sainte-Perpétue',
      'Sainte-Pétronille',
      'Sainte-Praxède',
      'Sainte-Rita',
      'Sainte-Rose-de-Watford',
      'Sainte-Sabine',
      'Saints-Anges',
      'Sayabec',
      'Scott',
      'Shannon',
      'Sillery',
      'Stoneham-et-Tewkesbury',
      'Témiscouata-sur-le-Lac',
      'Thetford Mines',
      'Tourville',
      'Trait-Carré',
      'Tring-Jonction',
      'Trois-Pistoles',
      'Val-Alain',
      'Val-Bélair',
      'Val-Brillant',
      'Vallée-Jonction',
      'Vanier',
      'Vieux-Bourg',
      'Vieux-Limoilou',
      'Vieux-Moulin',
      'Vieux-Québec–Cap-Blanc–colline Parlementaire',
    ];

    districts.forEach(el => {
      options.push(
        <Select.Option key={el} value={el}>
          {el}
        </Select.Option>
      );
    });

    return options;
  }

  generateMrcOption() {
    var options = [];

    var mrc = [
      'Beauce-Sartigan',
      'Bellechasse',
      'Charlevoix',
      'Charlevoix-Est',
      'Hors MRC',
      'Hors MRC \\ CMQ',
      'Kamouraska',
      "L'Ancienne-Lorette",
      "L'Île-d'Orléans \\ CMQ",
      "L'Islet",
      'La Côte-de-Beaupré \\ CMQ',
      'La Jacques-Cartier \\ CMQ',
      'La Matanie',
      'La Matapédia',
      'La Mitis',
      'La Nouvelle-Beauce',
      'Les Appalaches',
      'Les Basques',
      'Les Etchemins',
      'Lotbinière',
      'Montmagny',
      'Portneuf',
      'Rimouski-Neigette',
      'Rivière-du-Loup',
      'Robert-Cliche',
      'Saint-Augustin-De-Desmaures',
      'Témiscouata',
      'Ville de Lévis',
      'Ville de Québec',
      'Wendake',
    ];

    mrc.forEach(el => {
      options.push(
        <Select.Option key={el} value={el}>
          {el}
        </Select.Option>
      );
    });

    return options;
  }

  generateActionFieldOption() {
    var options = [];

    var { action_fields } = this.state;
    (action_fields || []).sort(function (el1, el2) {
      if (el1.label < el2.label) {
        return -1;
      }
      if (el1.label > el2.label) {
        return 1;
      }
      return 0;
    });

    action_fields.forEach(el => {
      options.push(
        <Select.Option key={el.id} value={el.id}>
          {el.label}
        </Select.Option>
      );
    });

    return options;
  }

  generateSectorOption() {
    var options = [];

    var { sectors } = this.state;
    (sectors || []).sort(function (el1, el2) {
      if (el1.label < el2.label) {
        return -1;
      }
      if (el1.label > el2.label) {
        return 1;
      }
      return 0;
    });

    sectors.forEach(el => {
      options.push(
        <Select.Option key={el.id} value={el.id}>
          {el.label}
        </Select.Option>
      );
    });

    return options;
  }

  generateSubsectorOption() {
    var options = [];

    var { subsectors } = this.state;
    (subsectors || []).sort(function (el1, el2) {
      if (el1.label < el2.label) {
        return -1;
      }
      if (el1.label > el2.label) {
        return 1;
      }
      return 0;
    });

    subsectors.forEach(el => {
      options.push(
        <Select.Option key={el.id} value={el.id}>
          {el.label}
        </Select.Option>
      );
    });

    return options;
  }

  generateUserOption() {
    var options = [];

    var { users } = this.state;
    (users || []).sort(function (el1, el2) {
      if (el1.name + ' ' + el1.surname < el2.name + ' ' + el2.surname) {
        return -1;
      }
      if (el1.name + ' ' + el1.surname > el2.name + ' ' + el2.surname) {
        return 1;
      }
      return 0;
    });

    users.forEach(el => {
      var found = el.user_type.rang !== USER_RANK_ORG;

      this.state.associations.forEach(association => {
        if (
          el.id === association.user_id &&
          association.id !== this.state.org.association_id
        ) {
          found = true;
        } else if (el.id !== this.state.org.associated_user_id && el.disabled) {
          found = true;
        }
      });

      !found &&
        options.push(
          <Select.Option key={el.id} value={el.id}>
            {el.name + ' ' + el.surname}
          </Select.Option>
        );
    });

    return options;
  }

  generateEditPage(pageTitle) {
    const { org, errors } = this.state;

    return (
      <Can do="edit" on={org}>
        <BackButton
          link={() =>
            this.props.navigate(`/organisations/${org.id}`, { replace: true })
          }
        />
        <h1>{pageTitle}</h1>

        <article className="box">
          <form onSubmit={this.handleEditSubmit}>
            <ul className="profile-main-content">
              <Can do="num_org" on={org}>
                <li>
                  <label>Numéro d&apos;organisme : </label>
                  <Input
                    name="organisation_number"
                    value={org.organisation_number}
                    onChange={e => this.handleChange(e)}
                  ></Input>
                </li>
              </Can>
              <li>
                <label>Nom, selon lettres-patentes : </label>
                <Input
                  name="patent_name"
                  value={org.patent_name}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Nom organismes, Lettres : </label>
                <Input
                  name="name"
                  value={org.name}
                  className={errors.name ? 'error-input' : ''}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Enregistrement ARC : </label>
                <Input
                  name="arc"
                  value={org.arc}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Enregistrement NEQ : </label>
                <Input
                  name="neq"
                  value={org.neq}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Courriel général : </label>
                <Input
                  name="email_general"
                  pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}"
                  title="Veuillez entrer une adresse courriel valide au format xxxx@xxx.xxx"
                  value={org.email_general}
                  className={errors.email_general ? 'error-input' : ''}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Site internet : </label>
                <Input
                  name="website"
                  pattern="(https?://)?[^\s\(\[&quot;<,>]*\.[^\s\[&quot;,><]*"
                  title="Veuillez entrer un site web valide au format https://xxxx ou http://xxxx"
                  value={org.website}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Téléphone service : </label>
                <Input
                  name="tel_service"
                  value={org.tel_service}
                  className={errors.tel_service ? 'error-input' : ''}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Téléphone administration : </label>
                <Input
                  name="tel_admin"
                  value={org.tel_admin}
                  className={errors.tel_admin ? 'error-input' : ''}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Cellulaire responsable : </label>
                <Input
                  name="tel_responsible"
                  value={org.tel_responsible}
                  className={errors.tel_responsible ? 'error-input' : ''}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Courriel responsable : </label>
                <Input
                  name="mail_responsible"
                  pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}"
                  title="Veuillez entrer une adresse courriel valide au format xxxx@xxx.xxx"
                  value={org.mail_responsible}
                  className={errors.mail_responsible ? 'error-input' : ''}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Adresse : </label>
                <Input
                  name="address"
                  value={org.address}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Code postal : </label>
                <Input
                  name="postal_code"
                  value={org.postal_code}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Ville / Municipalité : </label>
                <Input
                  name="city"
                  value={org.city}
                  className={errors.city ? 'error-input' : ''}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Arrondissement : </label>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={org.borough}
                  className={errors.borough ? 'error-input' : ''}
                  onChange={this.handleSelectChange('borough')}
                >
                  {this.generateBoroughOption()}
                </Select>
              </li>
              <li>
                <label>Quartier (si applicable) : </label>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={org.district}
                  className={errors.district ? 'error-input' : ''}
                  onChange={this.handleSelectChange('district')}
                >
                  {this.generateDistrictOption()}
                </Select>
              </li>
              <li>
                <label>Région : </label>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={org.region}
                  className={errors.region ? 'error-input' : ''}
                  onChange={this.handleSelectChange('region')}
                >
                  {this.generateRegionOption()}
                </Select>
              </li>
              <li>
                <label>Ville ou MRC : </label>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={org.mrc}
                  className={errors.mrc ? 'error-input' : ''}
                  onChange={this.handleSelectChange('mrc')}
                >
                  {this.generateMrcOption()}
                </Select>
              </li>
              <Can do="action_fields" on={org}>
                <li>
                  <label>Champ d&apos;action : </label>
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    value={org.action_field_id}
                    className={errors.action_field_id ? 'error-input' : ''}
                    onChange={this.handleSelectChange('action_field_id')}
                  >
                    {this.generateActionFieldOption()}
                  </Select>
                </li>
              </Can>
              <Can do="sectors" on={org}>
                <li>
                  <label>Secteur d&apos;intervention : </label>
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    value={org.sector_id}
                    className={errors.sector_id ? 'error-input' : ''}
                    onChange={this.handleSelectChange('sector_id')}
                  >
                    {this.generateSectorOption()}
                  </Select>
                </li>
              </Can>
              <Can do="subsectors" on={org}>
                <li>
                  <label>Sous-secteur : </label>
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    value={org.subsector_id}
                    className={errors.subsector_id ? 'error-input' : ''}
                    onChange={this.handleSelectChange('subsector_id')}
                  >
                    {this.generateSubsectorOption()}
                  </Select>
                </li>
              </Can>
              <li>
                <label>Appellation présidence : </label>
                <Input
                  name="presidency_appellation"
                  value={org.presidency_appellation}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Prénom présidence : </label>
                <Input
                  name="presidency_name"
                  value={org.presidency_name}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Nom présidence : </label>
                <Input
                  name="presidency_surname"
                  value={org.presidency_surname}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Appellation responsable : </label>
                <Input
                  name="responsible_appellation"
                  value={org.responsible_appellation}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Prénom responsable : </label>
                <Input
                  name="responsible_name"
                  value={org.responsible_name}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Nom responsable : </label>
                <Input
                  name="responsible_surname"
                  value={org.responsible_surname}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Année d&apos;association : </label>
                <Input
                  type="number"
                  name="organization_year"
                  value={org.organization_year}
                  min={1900}
                  max={2100}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <Can do="yearly_follow" on={org}>
                  <label>Suivi triennal : </label>
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    <Input
                      type="number"
                      style={{
                        width: '100px',
                        textAlign: 'center',
                        marginRight: '4px',
                      }}
                      name="yearly_follow_1"
                      value={org.yearly_follow_1}
                      min={0}
                      max={9}
                      onChange={e => this.handleChange(e)}
                    ></Input>
                    /
                    <Input
                      type="number"
                      style={{
                        width: '100px',
                        textAlign: 'center',
                        marginLeft: '4px',
                      }}
                      name="yearly_follow_2"
                      title="Veuillez entrer un chiffre entre 1 et 9"
                      value={org.yearly_follow_2}
                      min={0}
                      max={9}
                      onChange={e => this.handleChange(e)}
                    ></Input>
                  </span>
                </Can>
              </li>
              <li>
                <Checkbox
                  name="building_owner"
                  checked={isChecked(org.building_owner)}
                  onChange={e => this.handleCheckboxChange(e)}
                >
                  Propriétaire de l'édifice qu'il occupe
                </Checkbox>
              </li>
              <li>
                <Checkbox
                  name="other_building_owner"
                  checked={isChecked(org.other_building_owner)}
                  onChange={e => this.handleCheckboxChange(e)}
                >
                  Propriétaire d'un autre édifice
                </Checkbox>
              </li>
              <li>
                <label>Adresse de l'édifice : </label>
                <Input
                  name="building_address"
                  value={org.building_address}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <Checkbox
                  name="foundation_owner"
                  checked={isChecked(org.foundation_owner)}
                  onChange={e => this.handleCheckboxChange(e)}
                >
                  Propriétaire de la Fondation
                </Checkbox>
              </li>
              <li>
                <label>Nom de la Fondation : </label>
                <Input
                  name="foundation_name"
                  value={org.foundation_name}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Adresse fiduciaire : </label>
                <Input
                  name="fiduciary_address"
                  value={org.fiduciary_address}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Ville fiduciaire : </label>
                <Input
                  name="fiduciary_city"
                  value={org.fiduciary_city}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Province fiduciaire : </label>
                <Input
                  name="fiduciary_province"
                  value={org.fiduciary_province}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Code postal fiduciaire : </label>
                <Input
                  name="fiduciary_postal_code"
                  value={org.fiduciary_postal_code}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Point de service #1 : </label>
                <Input
                  name="service_point_1"
                  value={org.service_point_1}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Point de service #2 : </label>
                <Input
                  name="service_point_2"
                  value={org.service_point_2}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Point de service #3 : </label>
                <Input
                  name="service_point_3"
                  value={org.service_point_3}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <Can do="user" on={org}>
                <li>
                  <label>Utilisateur associé : </label>
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    value={org.associated_user_id}
                    className={errors.associated_user_id ? 'error-input' : ''}
                    onChange={this.handleSelectChange('associated_user_id')}
                  >
                    {this.generateUserOption()}
                  </Select>
                </li>
              </Can>
            </ul>
            <div className="buttons">
              <a
                className="button ghost slim"
                onClick={() =>
                  this.props.navigate(`/organisations/${org.id}`, {
                    replace: true,
                  })
                }
              >
                Annuler
              </a>
              <button disabled={this.state.isUpToDate}>
                Enregistrer les changements
              </button>
            </div>
          </form>
        </article>
      </Can>
    );
  }

  generateCreatePage(pageTitle) {
    const { org, errors } = this.state;

    return (
      <Can do="create" on={org}>
        <BackButton />
        <h1>{pageTitle}</h1>

        <article className="box">
          <form onSubmit={this.handleCreateSubmit}>
            <ul className="profile-main-content">
              <Can do="num_org" on={org}>
                <li>
                  <label>Numéro d&apos;organisme : </label>
                  <Input
                    name="organisation_number"
                    value={org.organisation_number}
                    onChange={e => this.handleChange(e)}
                  ></Input>
                </li>
              </Can>
              <li>
                <label>Nom, selon lettres-patentes : </label>
                <Input
                  name="patent_name"
                  value={org.patent_name}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Nom organismes, Lettres : </label>
                <Input
                  name="name"
                  value={org.name}
                  className={errors.name ? 'error-input' : ''}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Enregistrement ARC : </label>
                <Input
                  name="arc"
                  value={org.arc}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Enregistrement NEQ : </label>
                <Input
                  name="neq"
                  value={org.neq}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Région : </label>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  value={org.region}
                  className={errors.region ? 'error-input' : ''}
                  onChange={this.handleSelectChange('region')}
                >
                  {this.generateRegionOption()}
                </Select>
              </li>
              <li>
                <label>Courriel général : </label>
                <Input
                  name="email_general"
                  pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}"
                  title="Veuillez entrer une adresse courriel valide au format xxxx@xxx.xxx"
                  value={org.email_general}
                  className={errors.email_general ? 'error-input' : ''}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Site internet : </label>
                <Input
                  name="website"
                  pattern="(https?://)?[^\s\(\[&quot;<,>]*\.[^\s\[&quot;,><]*"
                  title="Veuillez entrer un site web valide au format https://xxxx ou http://xxxx"
                  value={org.website}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Téléphone service : </label>
                <Input
                  name="tel_service"
                  value={org.tel_service}
                  className={errors.tel_service ? 'error-input' : ''}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Année d&apos;association : </label>
                <Input
                  type="number"
                  name="organization_year"
                  value={org.organization_year}
                  min={1900}
                  max={2100}
                  onChange={e => this.handleChange(e)}
                ></Input>
              </li>
              <li>
                <label>Suivi triennal : </label>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <Input
                    type="number"
                    style={{
                      width: '100px',
                      textAlign: 'center',
                      marginRight: '4px',
                    }}
                    name="yearly_follow_1"
                    value={org.yearly_follow_1}
                    min={1}
                    max={9}
                    onChange={e => this.handleChange(e)}
                  ></Input>
                  /
                  <Input
                    type="number"
                    style={{
                      width: '100px',
                      textAlign: 'center',
                      marginLeft: '4px',
                    }}
                    name="yearly_follow_2"
                    value={org.yearly_follow_2}
                    min={1}
                    max={9}
                    onChange={e => this.handleChange(e)}
                  ></Input>
                </span>
              </li>
              <Can do="action_fields" on={org}>
                <li>
                  <label>Champ d&apos;action : </label>
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    value={org.action_field_id}
                    className={errors.action_field_id ? 'error-input' : ''}
                    onChange={this.handleSelectChange('action_field_id')}
                  >
                    {this.generateActionFieldOption()}
                  </Select>
                </li>
              </Can>
              <Can do="sectors" on={org}>
                <li>
                  <label>Secteur d&apos;intervention : </label>
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    value={org.sector_id}
                    className={errors.sector_id ? 'error-input' : ''}
                    onChange={this.handleSelectChange('sector_id')}
                  >
                    {this.generateSectorOption()}
                  </Select>
                </li>
              </Can>
              <Can do="subsectors" on={org}>
                <li>
                  <label>Sous-secteur : </label>
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    value={org.subsector_id}
                    className={errors.subsector_id ? 'error-input' : ''}
                    onChange={this.handleSelectChange('subsector_id')}
                  >
                    {this.generateSubsectorOption()}
                  </Select>
                </li>
              </Can>
              <Can do="user" on={org}>
                <li>
                  <label>Utilisateur associé : </label>
                  <Select
                    allowClear
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    value={org.associated_user_id}
                    className={errors.associated_user_id ? 'error-input' : ''}
                    onChange={this.handleSelectChange('associated_user_id')}
                  >
                    {this.generateUserOption()}
                  </Select>
                </li>
              </Can>
            </ul>
            <div className="buttons">
              <a
                className="button ghost slim"
                onClick={() => this.props.navigate(-1)}
              >
                Annuler
              </a>
              <button>Créer l&apos;organisme</button>
            </div>
          </form>
        </article>
      </Can>
    );
  }

  handleRequestsPagination(query, id) {
    return new Promise(function (resolve, reject) {
      query.filters.push(generateMaterialFilter('organization_id', id));
      requestService
        .listPaginate(
          query.page + 1,
          query.pageSize,
          query.filters,
          query.orderBy,
          query.orderDirection
        )
        .then(result => {
          resolve({
            data: result.data,
            page:
              result.total_pages > result.page
                ? result.page - 1
                : result.total_pages === 0
                  ? 0
                  : result.total_pages - 1,
            totalCount: result.total,
          });
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  handleNotesPagination(query, id) {
    return new Promise(function (resolve, reject) {
      query = JSON.parse(JSON.stringify(query));
      query.filters.push(generateMaterialFilter('organization_id', id));

      noteService
        .listPaginate(
          query.page + 1,
          query.pageSize,
          query.filters,
          query.orderBy,
          query.orderDirection
        )
        .then(result => {
          result.data.map(el => {
            el.ending_date = el.ending_date !== null;
            el.date = el.date ? new Date(el.date) : null;
            return el;
          });

          resolve({
            data: result.data,
            page:
              result.total_pages > result.page
                ? result.page - 1
                : result.total_pages === 0
                  ? 0
                  : result.total_pages - 1,
            totalCount: result.total,
          });
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  render() {
    const { edit, create } = this.props;

    var pageTitle = "Profil d'un organisme";
    if (edit) {
      pageTitle = "Édition d'un organisme";
    } else if (create) {
      pageTitle = "Création d'un organisme";
    }

    return (
      <Fragment>
        <Helmet>{title("Fiche d'un organisme")}</Helmet>

        <div className="organisations-color profile-styles">
          {this.generatePage(pageTitle)}
        </div>
      </Fragment>
    );
  }
}

function OrganisationPageWrapper(props) {
  const navigate = useNavigate();
  const params = useParams();

  return <OrganisationPage {...props} navigate={navigate} params={params} />;
}

const mapStateToProps = state => {
  return {
    user: {
      id: state.user.infos.id,
    },
  };
};

OrganisationPage.propTypes = {
  params: PropTypes.shape({
    id: PropTypes.string,
  }),
  navigate: PropTypes.func,
  user: PropTypes.shape({
    id: PropTypes.number,
  }),
  create: PropTypes.bool,
  edit: PropTypes.bool,
};

OrganisationPageWrapper.propTypes = {
  create: PropTypes.bool,
  edit: PropTypes.bool,
};

export default connect(mapStateToProps, null)(OrganisationPageWrapper);
